export const Background = ({ children }) => (
  <div
    style={{
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      overflow: 'auto',
      background: '#f0f2f5'
    }}
  >
    {children}
  </div>
)
